import React from 'react'
import { connect } from 'react-redux'
import { mapLanguageToComponentProps } from 'careers/i18n'
import { Error } from 'components/errors/error'
import { I18nComponentType } from 'careers/i18n-types'

interface UnpublishedProps {
  i18n: I18nComponentType
  children?: React.ReactNode | React.ReactNode[]
}

export function Unpublished({ i18n, children }: UnpublishedProps) {
  return (
    <Error heading={i18n.unpublished.title} content={i18n.unpublished.info}>
      {children}
    </Error>
  )
}

export default connect(mapLanguageToComponentProps())(Unpublished)
